import { define } from 'wicked-elements'

define('[data-component~="hours"]', {
  init() {
    this.fetchData(this.element.dataset.endpoint).then(({ html }) => {
      this.element.innerHTML = html || ''
    })
  },
  connected() {},
  disconnected() {},
  cacheData(key, data) {
    const dataWithTimestamp = {
      timestamp: Date.now(),
      data,
    }
    sessionStorage.setItem(key, JSON.stringify(dataWithTimestamp))
  },
  getCachedData(key) {
    const cachedData = sessionStorage.getItem(key)

    if (!cachedData) {
      return null
    }

    const { timestamp, data } = JSON.parse(cachedData)
    const currentTime = Date.now()
    const oneMinute = 1 * 60 * 1000

    // Check if the cached data is older than 1 minute
    if (currentTime - timestamp > oneMinute) {
      sessionStorage.removeItem(key)
      return null
    }

    return data
  },
  async fetchData(url) {
    // Check if the data is already cached
    const cachedData = this.getCachedData(url)

    if (cachedData) {
      return cachedData
    }

    // If the data is not cached, fetch it from the server
    try {
      const response = await fetch(url + `?t=${Date.now()}`)
      const data = await response.json()

      // Cache the data for future use
      this.cacheData(url, data)

      return data
    } catch (error) {
      return null
    }
  },
})
